import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export default function DeleteConfirmDialog({
  open,
  onClose,
  onConfirm,
  userName,
  theme,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 20px 60px rgba(0,0,0,0.15)",
          background: theme.palette.brain.table.tableBackground,
        },
      }}
      fullWidth
    >
      <DialogTitle
        sx={{
          color: theme.palette.secondary.main2,
        }}
      >
        Delete User
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          sx={{ color: theme.palette.brain.table.row.text }}
        >
          Are you sure you want to delete{" "}
          <strong style={{ color: theme.palette.secondary.main2 }}>
            {userName}
          </strong>
          ? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            textTransform: "none",
            fontSize: "0.75rem",
            borderColor: theme.palette.secondary.main2,
            color: theme.palette.secondary.main2,
            "&:hover": {
              borderColor: theme.palette.secondary.main2,
              color: theme.palette.secondary.main2,
            },
          }}
        >
          Cancel
        </Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
